import { Clickable, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Arrows } from '../../components';
import { NewsItem } from './';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 40px 0 0;

  @media (max-width: 1024px) {
    margin: 60px 0 0;
    width: 100vw;
  }
`;

const SectionHeader = styled.div`
  width: 1140px;
  align-self: center;
  display: flex;
  justify-content: space-between;

  h2  {
    font-size: 72px;
    letter-spacing: -3.5px;
  }

  @media (max-width: 1024px) {
    width: 100vw;

    h2 {
      font-size: 48px;
      margin: 0 13px;
      letter-spacing: -1.5px;
    }
  }
`;

const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;

  @media (max-width: 1024px) {
    margin-top: 13px;
  }
`;

const PurpleArea = styled.div`
  height: 203px;
  width: 100%;
  background-color: ${theme.DARK_PURPLE};
  margin-top: -184px;

  @media (max-width: 1024px) {
    height: 104px;
    margin-top: -94px;
  }
`;

const NewsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  padding-left: ${(props) => props.extraPad};
  scroll-behavior: smooth;

  @media (max-width: 1024px) {
    padding: 0 13px;
  }
`;

const GoToNews = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 1140px;
  align-self: center;
  margin-top: 25px;

  p {
    font-size: 20px;
    letter-spacing: -0.35px;

    b {
      letter-spacing: -0.6px;
    }
  }

  @media (max-width: 1024px) {
    width: 100vw;
    margin-top: 18px;
    margin-right: 13px;

    p {
      font-size: 16px;
    }
  }
`;
const ArrowsContainer = styled.div`
  margin-top: 45px;
`;

const News = ({ data }) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    newsRef = useRef(null),
    navigate = useNavigate();

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  if (!data?.length) return null;

  return (
    <Container>
      <SectionHeader>
        <Text h2 stencil>
          {t('website.latestNews')}
        </Text>

        <ArrowsContainer>
          <Arrows elem={newsRef} />
        </ArrowsContainer>
      </SectionHeader>

      <BackgroundContainer>
        <div id="newsScroll" style={{ paddingLeft: extraPad, overflowX: 'scroll' }} ref={newsRef}>
          <NewsContainer>
            {data.map((x, i) => (
              <NewsItem key={i} item={x} />
            ))}
          </NewsContainer>
        </div>

        <PurpleArea />
      </BackgroundContainer>

      <GoToNews>
        <Clickable onClick={() => navigate('/news')}>
          <Text>
            {t('website.goto')} <b>{t('website.news')}</b>
          </Text>
        </Clickable>
      </GoToNews>
    </Container>
  );
};

export default News;
